import HttpClientToken from '../../services/HttpClientToken';

import { defaultTipoExhorto, TipoExhortoProps } from '../../interfaces/catalogos/TipoExhortoInterface';

export const TipoExhortos = () => {

    return new Promise<TipoExhortoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoExhorto/', token)
            .then( ({ data } : { data : TipoExhortoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerTipoExhorto = () => {

    return new Promise<TipoExhortoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoExhorto/ObtenerTipoExhortos', token)
            .then( ({ data } : { data : TipoExhortoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarTipoExhorto = ( params: TipoExhortoProps ) => {

    return new Promise<TipoExhortoProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoExhorto/Actualizar', params, token)
            .then( ({ data } : { data : TipoExhortoProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve({ ...defaultTipoExhorto });
            });

        }

    });

}

export const AgregarTipoExhorto = ( params: TipoExhortoProps ) => {

    return new Promise<TipoExhortoProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoExhorto/Agregar', params, token)
            .then( ({ data } : { data : TipoExhortoProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve({ ...defaultTipoExhorto });
            });

        }

    });

}
